module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-forecast-12day-premium-380c393f1a0cb008419c4072487c12cd.webp";